// extracted by mini-css-extract-plugin
export default {"message":"EmY3K","countdown":"_2WDXk","countdown-value":"_3N5-_","countdownValue":"_3N5-_","countdown-ended":"_1ftGm","countdownEnded":"_1ftGm"};